import {isFeatureEnabled} from '@github-ui/feature-flags'
import {PreheatIssuesManager} from '@github-ui/preheat-issues-manager'
import {isLoggedIn} from '@github-ui/client-env'

const manager = new PreheatIssuesManager({
  isEnabled: () => !isFeatureEnabled('disable_preheating_for_issues') && isLoggedIn(),
  source: 'discussions',
})

manager.start()
